// src/lib/deleteFlow.ts
export async function deleteItemFlow<T extends { id?: string; title?: string }>(args: {
  item: T;
  entityName?: string;
  isTempId: (id: string) => boolean;

  // called only for temp ids
  onRemoveLocal: () => void;

  // called only for persisted ids
  onDeleteRemote: () => Promise<void>;

  // optional confirm
  confirm?: (title?: string, entityName?: string) => boolean | Promise<boolean>;
}) {
  const { item, entityName = 'item', isTempId, onRemoveLocal, onDeleteRemote, confirm } = args;

  const id = item.id;
  if (!id) return;

  if (confirm) {
    const ok = await confirm(item.title, entityName);
    if (!ok) return;
  }

  if (isTempId(id)) {
    onRemoveLocal();
    return;
  }

  await onDeleteRemote();
}
